import pluralize from 'pluralize'
import React, { FC } from 'react'
import Tag from '../Tag'
import { PassengerRequirements } from '../../types'

interface Props {
  requirements: PassengerRequirements
}

const PassengersTag: FC<Props> = ({ requirements }) => {
  const { adults, children, infants } = requirements

  if (adults + children + infants === 0) {
    return null
  }

  const summary = [
    adults > 0 ? `${adults} ${pluralize('adult', adults)}` : null,
    children > 0 ? `${children} ${pluralize('children', children)}` : null,
    infants > 0 ? `${infants} ${pluralize('infant', infants)}` : null,
  ].filter((s) => !!s)

  return (
    <Tag icon="users">
      x<span className="pl-1">{summary.join(', ')}</span>
    </Tag>
  )
}

export default PassengersTag
